import { IconSvg, IconSvgProps } from "./icon"

export default function Incognito(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <circle cx="7.5" cy="16.5" r="2.5" />
      <circle cx="16.5" cy="16.5" r="2.5" />

      <path d="M10 16.5h4" />

      <path d="M2.5 11h19" />
      <path d="M6 11l1.5-6h9l1.5 6" />
    </IconSvg>
  )
}
